import PropTypes from 'prop-types';
export const ProtocolSchema = PropTypes.oneOf(['http:', 'https:']);
